import { MAX_ZIP_BYTES } from '../../../core/constants/sg';

// Validación client-side de la subida de backups SG (admin-sg.md).
// El backend valida magic-bytes y tamaño (413), pero rechazamos antes de la red
// para dar un mensaje claro sin gastar una subida.

// Extensión `.zip` case-insensitive. NO se confía en el MIME: en Windows un .zip
// reporta `application/x-zip-compressed` o vacío, así que file.type no es fiable.
export function isZipFile(file) {
    return !!file && /\.zip$/i.test(file.name || '');
}

// Tamaño dentro del límite del backend (SG_UPLOAD_LIMIT = 60 MB → 413 si excede).
export function isWithinSizeLimit(file) {
    return !!file && file.size <= MAX_ZIP_BYTES;
}
